// BL-080 — merge-token helpers for the authoring editor. Pure functions so the
// token picker, chip renderer, and live preview can all share one source of
// truth. Token syntax matches the backend TokenResolver: {{key}} or {{key|fallback}}.

export const TOKEN_SOURCE = '\\{\\{\\s*([a-zA-Z0-9_]+)\\s*(?:\\|([^}]*))?\\}\\}';

// Built-in Standard catalog — used as a fallback so the picker works even if the
// /personalization/attributes endpoint isn't reachable (self-contained UX).
export const STANDARD_ATTRIBUTES = [
  { key: 'first_name', label: 'First name' },
  { key: 'last_name', label: 'Last name' },
  { key: 'company', label: 'Company' },
  { key: 'role', label: 'Role' },
  { key: 'plan_tier', label: 'Plan tier' },
  { key: 'segment', label: 'Segment' },
];

// Sample values for the "Preview (sample values)" line.
export const SAMPLE_VALUES = {
  first_name: 'Sarah',
  last_name: 'Lee',
  company: 'Acme',
  role: 'Admin',
  plan_tier: 'Pro',
  segment: 'Customer',
};

// Split text into ordered segments: { type:'text', value } | { type:'token', key, fallback, raw }.
export function parseTokens(text) {
  if (!text) return [];
  const re = new RegExp(TOKEN_SOURCE, 'g');
  const out = [];
  let last = 0;
  let m = re.exec(text);
  while (m !== null) {
    if (m.index > last) out.push({ type: 'text', value: text.slice(last, m.index) });
    out.push({ type: 'token', key: m[1], fallback: m[2] || '', raw: m[0] });
    last = m.index + m[0].length;
    m = re.exec(text);
  }
  if (last < text.length) out.push({ type: 'text', value: text.slice(last) });
  return out;
}

export function buildToken(key, fallback) {
  return fallback ? `{{${key}|${fallback}}}` : `{{${key}}}`;
}

// Insert a token string at a caret position (falls back to the end).
export function insertToken(text, token, caret) {
  const s = text || '';
  const pos = caret == null || caret < 0 || caret > s.length ? s.length : caret;
  return s.slice(0, pos) + token + s.slice(pos);
}

// Client-side resolve for the live preview.
export function resolveTokens(text, values = SAMPLE_VALUES) {
  if (!text) return text;
  return text.replace(new RegExp(TOKEN_SOURCE, 'g'), (_, key, fb) => {
    const v = values[key];
    return v != null && String(v).length ? String(v) : (fb || '');
  });
}

export function labelFor(key, catalog) {
  const all = [...(catalog?.standard || STANDARD_ATTRIBUTES), ...(catalog?.custom || [])];
  const found = all.find((a) => a.key === key);
  return found ? found.label : key;
}
